import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function Callback() {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash;
    const params = new URLSearchParams(
      hash.replace("#", "")
    );

    const token = params.get("id_token");

    if (token) {
      localStorage.setItem("idToken", token);

      // Redirect back
      const redirect =
        localStorage.getItem("postLoginRedirect") ||
        "/";

      localStorage.removeItem("postLoginRedirect");

      navigate(redirect);
    }
  }, [navigate]);

  return <p>Logging in...</p>;
}

export default Callback;
